import { fetchAuthSession } from 'aws-amplify/auth';
import { invitationControllerHandoffAnonymousSession } from '../../../generated/kubb/kubb-client.ts';
import { getStoredSession, removeStoredSession } from './anonymous-session-storage';
import { clearBearerTokenInterceptor } from '../useAddBearerTokenInAxios';

export async function performAnonymousSessionHandoff(tenantId: string): Promise<boolean> {
  const stored = getStoredSession(tenantId);
  if (!stored?.sessionId) return false;

  // Fetch the fresh Cognito token — the axios interceptor may still hold the
  // anonymous token when this runs right after signIn(). We must clear it so
  // it doesn't overwrite our explicit Authorization header.
  const session = await fetchAuthSession();
  const cognitoToken = session.tokens?.accessToken.toString();
  if (!cognitoToken) return false;

  clearBearerTokenInterceptor();

  await invitationControllerHandoffAnonymousSession(
    { sessionId: stored.sessionId },
    { headers: { Authorization: `Bearer ${cognitoToken}` } },
  );
  removeStoredSession(tenantId);
  return true;
}
